import PropTypes from "prop-types";

export default PropTypes.shape({
  description: PropTypes.string,
});
